module.exports = __webpack_public_path__ + "img/3-2-1.9ecf2747.png";